import React, { useMemo, useState, useEffect } from 'react';
import Spinner from 'jsx/elements/spinner';

import usePortfolioFilters from 'hooks/usePortfolioFilters';
import { usePortfolio } from 'components/PortfolioProvider';
import PortfolioCollection from './PortfolioCollection';
import { filterCustomerPortfolio } from './helpers';
import { useMonitoring } from 'components/MonitorProvider';

export default function PortfolioPage() {
  const [search, setSearch] = useState('');
  const { selected, monitors, selectMonitor } = useMonitoring();
  const { status, data, selectPortfolioMonitor } = usePortfolio();

  const onSearch = (e) => setSearch(e.target.value);
  const [filters, updateFilter] = usePortfolioFilters(data);

  const filteredCustomers = useMemo(() => {
    return filterCustomerPortfolio(data, filters, search);
  }, [data, filters, search]);

  const selectItems = (item) => {
    selectMonitor(item);
    selectPortfolioMonitor(item);
  };

  useEffect(() => {
    if (selected) {
      selectPortfolioMonitor(selected);
    }
  }, [selected]);

  const monitorItems = monitors.map((item) => ({
    name: item.name,
    onClick: () => selectItems(item),
    key: item.monitorId,
  }));

  if (status !== 'loaded') return <Spinner center />;

  return (
    <PortfolioCollection
      filters={filters}
      search={search}
      onSearch={onSearch}
      updateFilter={updateFilter}
      customers={filteredCustomers}
      showFilters={data.length > 0}
      resultSize={data.length}
      monitorItems={monitorItems}
      selectedMonitor={selected}
      selectPortfolioMonitor={selectPortfolioMonitor}
    />
  );
}
